/* eslint-disable @typescript-eslint/naming-convention */

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from 'environments/environment';

export interface SearchClient {
    id: number;
    name: string;
    surnames: string;
    email: string;
    identification: string;
}

export interface SearchPackageConsolidation {
    id: number;
    user_id: number;
    bill_id: number | null;
    billed: boolean;
}

export interface SearchPackage {
    id: number;
    tracking: string;
    status: string;
    provider: string;
    user_id: number;
    bill_id: number | null;
}

export interface SearchBill {
    id: number;
    total: number;
    paid: number;
    status: string;
    client_id: number;
    client_name: string;
    client_surnames: string;
}

export interface SearchBillLine {
    id: number;
    bill_id: number;
    tracking: string;
    name: string;
    description: string;
    client_id: number;
}

export interface SearchPrealert {
    id: number;
    tracking: string;
    provider: string;
    type: string;
    client_id: number;
}

export interface SearchPlanRequest {
    id: number;
    status: string;
    client_id: number;
    plan_id: number;
}

export interface SearchAdminNotification {
    id: number;
    title: string;
}

export interface SearchGroup<T> {
    items: T[];
    total: number;
}

export interface SearchResults {
    clients: SearchGroup<SearchClient>;
    package_consolidations: SearchGroup<SearchPackageConsolidation>;
    packages: SearchGroup<SearchPackage>;
    bills: SearchGroup<SearchBill>;
    bill_lines: SearchGroup<SearchBillLine>;
    prealerts: SearchGroup<SearchPrealert>;
    plan_requests: SearchGroup<SearchPlanRequest>;
    admin_notifications: SearchGroup<SearchAdminNotification>;
}

export interface SearchResponse {
    query: string;
    limit: number;
    results: SearchResults;
}

export type SearchGroupKey = keyof SearchResults;

@Injectable({ providedIn: 'root' })
export class SearchService {
    private _http = inject(HttpClient);
    private _urlBase = environment.urlBase;

    globalSearch(q: string, limit: number = 5): Observable<SearchResponse> {
        const headers = new HttpHeaders({
            Authorization: 'Bearer ' + localStorage.getItem('accessToken'),
        });

        const params = new HttpParams()
            .set('q', q)
            .set('limit', String(limit));

        return this._http.get<SearchResponse>(this._urlBase + 'search', { headers, params });
    }
}
